import {h, Component} from 'preact';
import {Formik, withFormik} from 'formik';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import Message from '@components/common/Message';

/**
 * Simple wrapper around Formik that uses the validate handler to broadcast "onChange" event that allows
 * the ability to track field states without the need of a form submission handler
 *
 * This component accepts the Formik interface
 * Any props passed are spread on the Formik component
 *
 * resource - https://jaredpalmer.com/formik/docs/api/formik
 */

export const TrackedFields = ( {onChange, ...props} ) => {
    return (
        <Formik
            validateOnChange={true}
            enableReinitialize={true}
            validate={values => onChange && onChange( values )}
            {...props}
        />
    );
};

export const Label = ( {error, className, children, ...props} ) => {
    return (
        <label className="input-label" {...props}>
            {children}
        </label>
    );
};

export const Hint = ( {error, className, children, ...props} ) => {
    return (
        <span className="input-hint block text-sm font-normal txt-c2 mb-1 " {...props}>
            {children}
        </span>
    );
};

export const InputFeedback = ( {error} ) =>
    error ? <div className="input-feedback error">{error.short || error}</div> : null;

export const FormFeedback = ( {errors, submitCount, className} ) => {

    if ( isEmptyOrNil( errors ) || submitCount < 1 ) {
        return null;
    }

    return (
        <Message fail className={`my-8 ${className}`}>
            <h3 className="font-bold mb-2">Please correct the following issues above before continuing</h3>
            <div className="pl-4">
                {Object.entries( errors ).map( ( [field, error] ) =>
                    <label className="m-0 text-white" htmlFor={field}>
                        - <span className="inline hover:underline">{error.long || error}</span>
                    </label>
                )}
            </div>
        </Message>
    );

};


